module['exports'] = [
  'اعوان',
  'ملک',
  'جبران',
  'احمد',
  'علی',
  'خان',
  'جان',
  'آفریدی',
  'باجوڑی',
  'میمن',
  'راجپوت',
  'عبدالی',
  'نیازی',
  'شریف',
  'چوہدری',
  'ملوک',
  'اللَہ',
  'شنواری',
  'حسین',
  'الحق',
];
